module.exports = __webpack_public_path__ + "img/C6.d105b41f.png";